import IModel from "./model";

export enum PriceCurrencyEnum {
  SEK = 'SEK',
  EUR = 'EUR',
  NOK = 'NOK',
  DKK = 'DKK',
};

export interface IProducerBillingInfo {
  companyName?: string;
  organizationNumber?: string;

  location?: string;
  latitude?: number;
  longitude?: number;

  street?: string;
  postalCode?: string;
  city?: string;
  country?: number;
  email?: string;
  phoneNumber?: string;
}

export interface IProducer extends IModel {
    id?: string;
    phone?: string;
    email?: string;
    name?: string;
    username?: string;
    status?: string; // TODO enum
    isStore?: boolean;
    storeId?: string;
    nonLocal?: boolean;
    enablePricePlan?: boolean;
    isMultiBrand?: boolean;
    enableProductAssistant?: boolean;
    enableInsights?: boolean;
    province?: string;
    description?: string;
    whattodo?: string;
    shortStory?: string;
    
    companyPrefixes?: string[];
    stripeCustomerId?: string|null;
    stripeCustomerName?: string|null;
    stripeCustomerEmail?: string|null;
    stripeCustomerDeleted?: boolean|null;

    duplicateCustomerError?: boolean;

    organizations?: string[];
    organizationGroupIdentifier?: string;

    billingInfo?: IProducerBillingInfo;
    profiles?: string[];
    nameNordicDistributor?: string,
    apoteaPriceCurrency?: PriceCurrencyEnum,
}

export default IProducer;
